module.exports = __webpack_public_path__ + "img/facebook.5464c798.svg";